export enum ContentType {
  Pdf = 1,
  Url = 2
}
